import { render, staticRenderFns } from "./QuestionPreview.vue?vue&type=template&id=0d821dc4&scoped=true"
import script from "./QuestionPreview.ts?vue&type=script&lang=ts&external"
export * from "./QuestionPreview.ts?vue&type=script&lang=ts&external"
import style0 from "./QuestionPreview.vue?vue&type=style&index=0&id=0d821dc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d821dc4",
  null
  
)

export default component.exports